module.exports = __webpack_public_path__ + "static/media/Rueda-Herramienta-Superior.91a39313.jpg";